<div class="loading-container" *ngIf="isLoading">
  <mat-spinner></mat-spinner>
  Carregando...
</div>

<h3 class="mb-3">Importar Movimentação</h3>

<form [formGroup]="formGroup" class="row" (submit)="onSubmit()">
  <mat-form-field class="col-12">
    <mat-label>Tipo de Movimentação</mat-label>
    <mat-select formControlName="tipoMovimentacao">
      <mat-option [value]="0">Inclusão</mat-option>
      <mat-option [value]="1">Alteração</mat-option>
      <mat-option [value]="2">Exclusão</mat-option>
      <mat-option [value]="3">Posição Cadastral</mat-option>
    </mat-select>
    <mat-error>Este campo é obrigatório</mat-error>
  </mat-form-field>

  <app-document-input
    [descricao]="descricaoArquivo"
    [file]="formGroup.controls.documento.value"
    [hasValue]="!!formGroup.controls.documento.value"
    (changed)="formGroup.controls.documento.setValue($event)"
    (removed)="formGroup.controls.documento.setValue(null)"
    [sent]="submitted"
  ></app-document-input>

  <div class="d-flex justify-content-between mt-3">
    <div class="d-flex">
      <button
        mat-stroked-button
        color="primary"
        type="button"
        (click)="matDialogRef.close()"
      >
        Fechar
      </button>
      <ng-container *ngIf="formGroup.controls.tipoMovimentacao.value !== null">
        <a
          mat-stroked-button
          color="primary"
          class="ms-2 d-flex align-items-center"
          href="../../../../../assets/modelos-importacao/Layout_Beneficiarios_Exc.xlsx"
          download
          *ngIf="formGroup.controls.tipoMovimentacao.value === 2"
        >
          <mat-icon>download</mat-icon>
          Baixar Modelo Exclusão
        </a>
        <a
          mat-stroked-button
          color="primary"
          class="ms-2 d-flex align-items-center"
          href="../../../../../assets/modelos-importacao/Layout_Beneficiarios_Inc_Alt_Pos.xlsx"
          download
          *ngIf="formGroup.controls.tipoMovimentacao.value !== 2"
        >
          <mat-icon>download</mat-icon>
          Baixar modelo
        </a>
      </ng-container>
    </div>
    <button mat-raised-button type="submit" color="primary">Enviar</button>
  </div>
</form>
